"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.brandedFaresFactory = brandedFaresFactory;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
function brandedFaresFactory(_ref) {
  var fares = _ref.fares,
    code = _ref.code,
    $currency = _ref.$currency;
  return {
    code: code,
    cabinBaggage: baggageFareFactory(fares === null || fares === void 0 ? void 0 : fares.cabinBaggage, $currency),
    checkInBaggage: baggageFareFactory(fares === null || fares === void 0 ? void 0 : fares.checkInBaggage, $currency),
    underSeatBaggage: baggageFareFactory(fares === null || fares === void 0 ? void 0 : fares.underSeatBaggage, $currency),
    flightChange: brandedFareRuleFactory(fares === null || fares === void 0 ? void 0 : fares.flightChange, $currency),
    cancellation: brandedFareRuleFactory(fares === null || fares === void 0 ? void 0 : fares.cancellation, $currency),
    checkinInfo: brandedCheckinRuleFactory(fares === null || fares === void 0 ? void 0 : fares.airportCheckIn, fares === null || fares === void 0 ? void 0 : fares.onlineCheckIn, $currency)
  };
}
function baggageFareFactory(baggage, $currency) {
  var weight = baggage === null || baggage === void 0 ? void 0 : baggage.weight;
  var quantity = baggage === null || baggage === void 0 ? void 0 : baggage.quantity;
  var price = (baggage === null || baggage === void 0 ? void 0 : baggage.price) || 0;
  var isFree = price === 0;
  var isIncluded = !!(parseInt(weight, 10) || quantity) && isFree;
  return {
    weight: weight,
    quantity: quantity,
    price: price,
    dimensions: baggage === null || baggage === void 0 ? void 0 : baggage.dimensions,
    displayPrice: $currency.formatPriceWithDecimals(price, 0),
    currency: $currency.currentCurrency,
    isFree: isFree,
    isIncluded: isIncluded
  };
}
function brandedFareRuleFactory(fareRule, $currency) {
  var price = (fareRule === null || fareRule === void 0 ? void 0 : fareRule.price) || 0;
  return {
    price: price,
    isAvailable: !(0, _isEmpty2.default)(fareRule),
    withFees: price > 0,
    displayPrice: $currency.formatPriceWithDecimals(price, 0),
    currency: $currency.currentCurrency
  };
}
function brandedCheckinRuleFactory(airportCheckIn, onlineCheckIn, $currency) {
  return {
    hasFreeAirportCheckin: !Number(airportCheckIn === null || airportCheckIn === void 0 ? void 0 : airportCheckIn.price),
    checkinTimeBeforDeparture: onlineCheckIn === null || onlineCheckIn === void 0 ? void 0 : onlineCheckIn.timeBeforeDeparture,
    timeUnit: onlineCheckIn === null || onlineCheckIn === void 0 ? void 0 : onlineCheckIn.timeUnit,
    airportCheckinPrice: $currency.convertAndFormatPriceValue({
      price: Number((airportCheckIn === null || airportCheckIn === void 0 ? void 0 : airportCheckIn.price) || 0),
      decimal: 0
    }),
    currency: $currency.currentCurrency
  };
}